import React from 'react';
import Select from 'components/ui/Select';

const StatusFilter = ({ onFilter, currentFilter }) => {
  const statusOptions = [
    { value: 'all', label: 'Tutti gli stati' },
    { value: 'active', label: 'Attivi' },
    { value: 'suspended', label: 'Sospesi' },
    { value: 'banned', label: 'Bannati' }
  ];

  return (
    <Select
      value={currentFilter}
      onChange={(value) => onFilter(value)}
      options={statusOptions}
      className="w-full"
    />
  );
};

export default StatusFilter;